// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DescriptorList__descriptorList__VIitQ{display:flex;flex-flow:column nowrap}
`, "",{"version":3,"sources":["webpack://./src/js/apps/indexDocuments/components/DescriptorList/DescriptorList.scss"],"names":[],"mappings":"AAAA,uCACI,YAAa,CACb,uBAAwB","sourcesContent":[".descriptorList {\n    display: flex;\n    flex-flow: column nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"descriptorList": `DescriptorList__descriptorList__VIitQ`
};
export default ___CSS_LOADER_EXPORT___;
